import { Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconSet } from '../../types/icon.types';

@Component({
  selector: 'ds-icon',
  imports: [CommonModule],
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
})
export class IconComponent {
  public set = input<IconSet>('basic');
  public name = input.required<string>();
  public secondaryName = input<string>();

  protected link = computed(() => `assets/icons/${this.set() ? `${this.set()}/` : ''}icons.svg#${this.name()}`);
  protected secondaryLink = computed(() => `assets/icons/${this.set() ? `${this.set()}/` : ''}icons.svg#${this.secondaryName()}`);
}
